module.exports = __webpack_public_path__ + "static/media/Oliva-Serif-Alts-1.434cf4e0.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Oliva-Serif-Alts-1.woff
// module id = 3388
// module chunks = 71